import {z} from 'zod'

import {Conditionals as ConditionalsCfg} from './Conditionals'
import {first} from 'remeda'
import {SheetParser, ChartCfg, ChartMeta} from './chartMeta.types'
import {ChartComponentProps, ChartType} from './charts'

export type NameValue = {name: string; value: number}
export interface Conditional {
  title?: string
  ifTrue?: NameValue
  ifFalse?: NameValue
  likelihood?: number
}

const zodQuestion = z.object({
  long: z.string(),
  short: z.string(),
  value: z.number()
})
type QuestionCfg = z.infer<typeof zodQuestion>
type Question = QuestionCfg // happen to be the same

const zodConditional = z.object({
  conditional: z.string().optional(),
  likelihood: z.number(),
  true_name: z.string(),
  true_likelihood: z.number(),
  false_name: z.string(),
  false_likelihood: z.number()
})
type ConditionalCfg = z.infer<typeof zodConditional>

const parser: SheetParser<ConditionalsCfg> = {
  question: zodQuestion,
  conditional: zodConditional
}

export type ConditionalsProps = ChartComponentProps<{
  conditionals?: Conditional[]
  question?: Question
}> & {onHover?: (c?: Conditional) => void}

/** this is what vets saved and aligns with the sheets/form */
export type ConditionalsCfg = ChartCfg<{
  question: QuestionCfg[]
  conditional: ConditionalCfg[]
}> &
  Pick<ConditionalsProps['chart'], 'source'>

const type: ChartType = 'Conditionals'

export const conditionalsMeta: ChartMeta<ConditionalsProps['chart'], ConditionalsCfg> = {
  type,
  title: 'Conditional bars',
  View: ConditionalsCfg,
  edit: {
    initial: () => ({source: ''}),
    parser: parser,
    cfgToProps: ({cfg, sheets: {question, conditional}}) => ({
      source: cfg?.source,
      question: question ? first(question) : undefined,
      conditionals: conditional?.map(
        ({conditional, likelihood, true_name, true_likelihood, false_name, false_likelihood}) => ({
          title: conditional,
          likelihood,
          ifTrue: {name: true_name, value: true_likelihood},
          ifFalse: {name: false_name, value: false_likelihood}
        })
      )
    }),
    cfgSchema: {}
  }
}
